/* Elegance Coque — « Acheter maintenant » hors fiche produit (cartes, aperçu rapide, petit sélecteur).
   ECCod.open(urlProduit, idVariante, quantité) — appelé par ECBuy.buyNow (ec-buy.js).
   Intégration native EasySell (Form Placement « Whole store ») : hors fiche produit, EasySell ouvre
   son formulaire en popup avec le contenu du panier (window.openTysloForm, ou son bouton « es-popup-button-drawer »).
   On met donc la variante choisie (couleur + modèle) au panier avec la bonne quantité,
   puis on clique le bouton EasySell : le formulaire s'ouvre sur la page actuelle, sans navigation. */
(function () {
  if (window.ECCod) { return; }
  var d = document, W = window;
  var ROOT = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || '/';
  var busy = false;

  /* bouton fourni par EasySell (inséré par l'app dans le tiroir panier) */
  function esButton() {
    return d.querySelector('#es-popup-button.es-popup-button-drawer') || d.querySelector('.es-popup-button-drawer') || d.querySelector('#es-popup-button');
  }
  function waitButton(ms) {
    return new Promise(function (res) {
      var t0 = Date.now();
      (function loop() {
        var b = esButton();
        if (b || Date.now() - t0 > ms) { res(b); return; }
        setTimeout(loop, 80);
      })();
    });
  }
  function json(url, body) {
    return fetch(ROOT + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { throw j; } return j; }); });
  }
  /* la ligne de la variante est mise à la quantité choisie (pas d'ajout en double si elle est déjà au panier) */
  function putInCart(id, qty) {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var line = (c.items || []).filter(function (i) { return i.variant_id === id; })[0];
      if (line) { return line.quantity === qty ? c : json('cart/change.js', { id: line.key, quantity: qty }); }
      return json('cart/add.js', { items: [{ id: id, quantity: qty }] });
    });
  }
  function loading(on) {
    d.documentElement.classList.toggle('ec-cod-loading', on);
    [].slice.call(d.querySelectorAll('[data-ec-buy-busy]')).forEach(function (b) { if (!on) { b.removeAttribute('aria-busy'); b.removeAttribute('data-ec-buy-busy'); } });
  }
  function toast(msg) {
    var t = d.createElement('div');
    t.className = 'ec-cod-toast'; t.setAttribute('role', 'alert'); t.textContent = msg;
    t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;max-width:calc(100% - 32px);padding:12px 16px;border-radius:10px;background:#111;color:#faf7f0;font-size:14px;box-shadow:0 8px 24px rgba(0,0,0,.25)';
    d.body.appendChild(t); setTimeout(function () { t.remove(); }, 3800);
  }
  function fallback(url, id, qty) {
    /* EasySell absent de la page : fiche produit avec la variante, le formulaire s'y ouvre */
    location.href = String(url || '').split('?')[0] + '?variant=' + id + '&quantity=' + qty;
  }
  function open(url, id, qty) {
    id = Number(id); qty = Math.max(1, Number(qty) || 1);
    if (!id || busy) { return; }
    busy = true; loading(true);
    var act = d.activeElement;
    if (act && act.closest && act.closest('button')) { var b0 = act.closest('button'); b0.setAttribute('aria-busy', 'true'); b0.setAttribute('data-ec-buy-busy', ''); }
    putInCart(id, qty)
      .then(function () {
        /* openTysloForm : fonction publiée par EasySell elle-même (easysell.js : window.openTysloForm = popupListner),
           le même gestionnaire que son bouton du tiroir panier ; elle relit le panier puis ouvre la popup */
        if (typeof W.openTysloForm === 'function') { return W.openTysloForm(true); }
        return waitButton(1500).then(function (b) { if (b) { b.click(); } else { fallback(url, id, qty); } });
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'Ce produit n’est pas disponible dans cette quantité.';
        toast(msg);
      })
      .then(function () { busy = false; loading(false); });
  }
  W.ECCod = { open: open };
})();